// Email regex for validation of correct email addresses, regex from https://emailregex.com/
// eslint-disable-next-line
export const EMAIL_REGEX: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i
export const BROADWORKS_USER_BASIC_REGEX: RegExp = /.*@.*/i
